<div class="grid p-2 bg-white border-round-lg">
   <div class="flex flex-row gap-2">
      <div class="min-box-buttons flex flex-row gap-2">
         <p-button
            severity="secondary"
            [label]="'DATA.COMMON.ACTIONS.FILTERS' | translate"
            [badge]="selectedFilters?.length! > 0 ? selectedFilters?.length!.toString() : undefined"
            (onClick)="opFilter.toggle($event)"
            icon="pi pi-filter"
            class="align-items-center"
         />
      </div>

      <p-divider *ngIf="selectedFilters?.length! > 0" class="-ml-1" layout="vertical"></p-divider>

      <div class="flex flex-wrap gap-2 max-w-full align-items-center">
         <p-button
            class="min-width-button"
            *ngFor="let filter of selectedFilters"
            styleClass="chip-filter-button text-500"
            (click)="removeAppliedFilter(filter.filter.id)"
         >
            <ng-container [ngSwitch]="filter.filter.type">
               <!-- Dropdown display -->
               <ng-container *ngSwitchCase="FilterType.Dropdown" class="text-500">
                  <span class="text-500 mr-2"> {{ filter.filter.label }}</span>
                  <span class="text-600 font-semibold">{{ getOptionLabels(filter) }}</span>
                  <span class="count" *ngIf="getOptionCount(filter.filter, filter.value)">
                     ({{ getOptionCount(filter.filter, filter.value) }})
                  </span>
               </ng-container>

               <!-- Multiselect display -->
               <ng-container *ngSwitchCase="FilterType.Multiselect" class="text-500">
                  <span class="text-500 mr-2"> {{ filter.filter.label }}</span>
                  <span class="text-600 font-semibold"> {{ getOptionLabels(filter) }} </span>
               </ng-container>

               <!-- Input text -->
               <ng-container *ngSwitchCase="FilterType.Input" class="text-500">
                  <span class="text-500 mr-2"> {{ filter.filter.label }}</span>
                  <span class="text-600 font-semibold"> {{ truncateLongWords(filter.value) }} </span>
               </ng-container>

               <!-- Radio display -->
               <ng-container *ngSwitchCase="FilterType.Checkbox" class="text-500">
                  <span class="text-500 mr-2"> {{ filter.filter.label }}</span>

                  <ng-container *ngIf="getRadioButtonLabel(filter) as filtered">
                     <div class="flex flex-wrap gap-1 align-items-center">
                        <p-chip *ngFor="let item of filtered?.displayed" [label]="item"></p-chip>

                        <span *ngIf="filtered.moreCount > 0" class="text-600 font-semibold">
                           +{{ filtered.moreCount }} {{ 'DATA.COMMON.GENERIC.MORE' | translate }}
                        </span>
                     </div>
                  </ng-container>
               </ng-container>

               <!-- Range -->
               <ng-container *ngSwitchCase="FilterType.Range" class="text-500">
                  <span class="text-500 mr-2"> {{ filter.filter.label }}</span>
                  <span class="text-600 font-semibold">{{ filter.value.min }} - {{ filter.value.max }} EUR</span>
               </ng-container>

               <ng-container *ngSwitchCase="FilterType.DateRange" class="text-500">
                  <span class="text-500 mr-2">{{ filter.filter.label }}</span>

                  <!-- "Hoy" if same-day and today -->
                  <ng-container *ngIf="isFullDayRange(filter.value.start, filter.value.finish)">
                     <ng-container *ngIf="this.isTodayFullRange(filter.value.start, filter.value.finish); else sameDayOther">
                        <span class="text-600 font-semibold">Hoy</span>
                     </ng-container>
                     <ng-template #sameDayOther>
                        <span class="text-600 font-semibold">
                           {{ filter.value.start | timezoneDate: false }} (24h)
                        </span>
                     </ng-template>
                  </ng-container>

                  <!-- Else normal range -->
                  <ng-container *ngIf="!isFullDayRange(filter.value.start, filter.value.finish)">
                     <span class="text-600 font-semibold">
                        {{ filter.value.start | timezoneDate: false }} -
                        {{ filter.value.finish | timezoneDate: false }}
                     </span>
                  </ng-container>
               </ng-container>

               <!-- Composed (WORKFLOW) -> create a proper component -->
               <ng-container *ngSwitchCase="FilterType.Composed" class="text-500 flex align-items-center">
                   <app-composed-filter-display [filter]="filter"></app-composed-filter-display>
               </ng-container>

               <!--Chips-->
               <ng-container *ngSwitchCase="FilterType.Chips" class="text-500 flex align-items-center gap-2">
                  <span class="text-500 mr-2"> {{ filter.filter.label }}</span>

                  <ng-container *ngIf="getFilteredItems(filter.value) as filtered">
                     <div class="flex flex-wrap gap-1 align-items-center">
                        <p-chip *ngFor="let item of filtered.displayed" [label]="item"></p-chip>

                        <span *ngIf="filtered.moreCount > 0" class="text-600 font-semibold">
                           +{{ filtered.moreCount }} {{ 'DATA.COMMON.GENERIC.MORE' | translate }}
                        </span>
                     </div>
                  </ng-container>
               </ng-container>

               <!-- Default display for other types -->
               <ng-container *ngSwitchDefault> {{ filter.filter.label }}: {{ filter.value }} </ng-container>

               <i class="pi pi-times-circle text-500 ml-2"></i>
            </ng-container>
         </p-button>
         <p-button
            *ngIf="selectedFilters && selectedFilters.length > 0"
            [rounded]="true"
            severity="secondary"
            (onClick)="reset()"
            icon="pi pi-undo"
            [pTooltip]="'DATA.COMMON.GENERIC.RESET_FILTERS' | translate"
         />
      </div>
   </div>
</div>

<p-overlayPanel class="p-0" #opFilter (onShow)="itCloseOp(true)" (onHide)="itCloseOp(false)">
   <app-filter-selector
       *ngIf="showFilterSelector"
      class="col p-0"
      [filters]="filters"
      [resetFiltersTrigger]="resetTrigger"
      [removeFilterId]="removedFilterId"
      [itCloses]="this.showFilterSelector"
      (applyFilters)="onAppliedFiltersChange($event)"
      (emitSearch)='search()'
   >
   </app-filter-selector>
</p-overlayPanel>
